import axios from 'axios';

function logError(error) {
	console.log(error);
	throw error;
}

class TechnologyTransferAssociationService {
	getTechnologyTransferAssociationData(language) {
		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/TechnologyTransferAssociation?
		`,
				{
					populate: 2,
					lang: language
				}
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new TechnologyTransferAssociationService();
